import {BulkActionProps, DateInput, ListProps, NumberInput, SelectInput,} from "ra-ui-materialui";

import {
    AutocompleteInput, BooleanInput, BulkDeleteButton, DatagridProps, NullableBooleanInput,
    NumberField,
    ReferenceInput, useListContext, useResourceContext
} from "react-admin";
import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {useOptions} from "../../shared/hooks/useOptions";
import {ReferenceInputAccountCompany} from "../../components/reference-inputs/ReferenceInputAccountCompany";
import {getDefaultListProps, initField} from "../../shared/utils";
import {ReferenceInputSubject} from "../../components/reference-inputs/ReferenceInputSubject";
import {CustomList} from "../../components/CustomList";
import {DebtColletionDatagrid} from "./DebtColletionDatagrid";
import {Grid} from "@material-ui/core";
import {StatCard} from "../../components/StatCard";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import {useEffect, useState} from "react";
import {BulkAssigned} from "./BulkAssigned";
import {PrintInvoiceTimeTableButton} from "../PaymentSchedule/bulkAction/PrintInvoiceTimeTableButton";
import {
    PrintInvoiceTimeTableButtonSingleClient
} from "../PaymentSchedule/bulkAction/PrintInvoiceTimeTableButtonSingleClient";
import {SendInvoiceSumButton} from "../PaymentSchedule/bulkAction/SendInvoiceSumButton";
import {SendInvoiceButton} from "../PaymentSchedule/bulkAction/SendInvoiceButton";
import {AddPaymentStatusPayedBulkButton} from "../PaymentSchedule/bulkAction/AddPaymentStatusPayedBulkButton";
import {ExportSelectedExcel} from "../PaymentSchedule/bulkAction/ExportSelectedExcel";
import CheckBox from "@material-ui/icons/CheckBox";
import {client, getRealResource} from "../../dataProvider";
import {useQuery} from "react-query";
import {useListQueryParams} from "../../shared/hooks/useListQueryParams";


export const BulkActions = (props: BulkActionProps) => {
    const {selectedIds} = props;
    return (
        <>
            <SendInvoiceSumButton ids={selectedIds}/>
            <PrintInvoiceTimeTableButton ids={selectedIds} type="T"/>
            <BulkAssigned/>
        </>
    );
};

const DebtColletionHeader = (props: DatagridProps) => {
    const {data, selectedIds} = useListContext(props);
    const [stats, setStats] = useState({
        tot_amount: {id: 0, tot_amount: 0},
        selected_amount: {id: 0, selected_amount: 0},
    });
    const query = useListQueryParams();
    const { filterValues, filter, ids } = useListContext();
    const resource = useResourceContext();
    const url = `${getRealResource(resource)}/statistics`;


    const { data: st } = useQuery(
        [url, query, filterValues, filter, ids],
        () =>
            client(url, {
                method: "GET",
                params: {
                    ...query,
                    ...filter,
                    ...filterValues,
                },
            }),
    );

    useEffect(() => {
        if(st)
            setStats({
                ...stats,
                tot_amount: {id: 0, tot_amount: st.tot_amount},
            })
    }, [st]);


    useEffect(() => {
        let selected_amount = 0
        for (const d in data) {
            if (selectedIds.includes(data[d].id)) {
                selected_amount += data[d].amount
            }
        }
        setStats({
            ...stats,
            selected_amount: {
                id: 0,
                selected_amount: selected_amount
            },
        })

    }, [data, selectedIds])

    return (
        <Grid container>
            <Grid item xs={12} sm={6}>
                <StatCard
                    label={
                        <NumberField
                            record={stats.tot_amount}
                            source="tot_amount"
                            variant="inherit"
                            options={{
                                style: "currency",
                                currency: "EUR",
                            }}
                        />
                    }
                    icon={<AttachMoneyIcon/>}
                    subtitle="Totale importo"
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <StatCard
                    label={
                        <NumberField
                            record={stats.selected_amount}
                            source="selected_amount"
                            variant="inherit"
                            options={{
                                style: "currency",
                                currency: "EUR",
                            }}
                        />
                    }
                    icon={<CheckBox/>}
                    subtitle="Totale selezionato"
                />
            </Grid>

        </Grid>
    );
}


export const DebtColletionList = (props: ListProps) => {
    const {data: options} = useOptionsResource("GET");
    const {data: optionsTerms} = useOptions("payment-terms", "GET");
    const {data: optionsInvoice} = useOptions("invoices", "GET");
    const {data: optionsInvoiceReminder} = useOptions("invoice_reminder", "GET");

    const filters =
        options && optionsTerms && optionsInvoice && optionsInvoiceReminder
            ? [
                <NumberInput
                    {...initField("sequencerange_max", options)}
                    label="a N° Ft."
                />,
                <ReferenceInput
                    {...initField("assigned", options)}
                    reference="autocomplete/employee"
                    className="filter-field-small"
                    filter={{debt_collection: true}}
                    label="Assegnato a"
                    alwayOn
                >
                    <AutocompleteInput optionText="label" />
                </ReferenceInput>,
                <ReferenceInputAccountCompany
                    {...initField("company", optionsInvoice)}
                    alwaysOn
                />,
                <ReferenceInputSubject
                    filter={{ type: "client" }}
                    {...initField("client", optionsInvoice)}
                    alwaysOn
                />,
                <NumberInput
                    {...initField("sequencerange_min", options)}
                    label="da N° Ft."
                />,
                <DateInput
                    {...initField("last_reminder__date_activity_before", options)}
                    label="Data attività al"
                />,
                <DateInput
                    {...initField("last_reminder__date_activity_after", optionsInvoice)}
                    label="Data attività dal"
                />,
                <DateInput
                    {...initField("invoice_date_before", options)}
                    label="Data fattura al"
                />,
                <DateInput
                    {...initField("invoice_date_after", optionsInvoice)}
                    label="Data fattura dal"
                />,
                <DateInput
                    {...initField("expiration_date_before", options)}
                    label="Data scadenza fino al"
                />,
                <SelectInput
                    {...initField("exclude_invoice_status", options, "array")}
                    choices={options.invoice.children.status.choices}
                    label="Escludi stato fattura"
                    className="filter-field-small"
                />,
                <SelectInput
                    choices={optionsInvoiceReminder.communication_method.choices}
                    {...initField("communication_method", optionsInvoiceReminder, "array")}
                    label="Metodo di comunicazione"
                    alwayOn
                />,
                <SelectInput
                    choices={optionsTerms.method.choices}
                    {...initField("payment_method", optionsTerms, "array")}
                    label="Metodo di pagamento"
                    alwayOn
                />,
                <NumberInput
                    {...initField("invoice__sequence_number", optionsInvoice)}
                    label="N.Fatt"
                />,
                <NumberInput
                    {...initField("reminder_gte", options)}
                    label="N° min solleciti"
                />,
                <NullableBooleanInput
                    {...initField("reminder", options)}
                    alwayOn
                    label="Sollecitato"
                />,
                <SelectInput
                    {...initField("invoice__status", options, "array")}
                    choices={options.invoice.children.status.choices}
                    label="Stato fattura"
                    className="filter-field-small"
                />,
            ]
            : [];

    return options && optionsTerms && optionsInvoice ? (
        <CustomList
            sort={{field: "invoice__client__business_name", order: "ASC"}}
            filters={filters}
            {...getDefaultListProps(props)}
            filterDefaultValues={{
                company: 1,
                payment_method: ["MP05"],
                expiration_date_before: new Date().toISOString().split("T")[0],
                cashed: false,
                exclude_invoice_status: "P",
            }}
            topElement={<DebtColletionHeader/>}
            bulkActionButtons={<BulkActions/>}
        >
            <DebtColletionDatagrid
                options={options}
            />
        </CustomList>
    ) : null;
};
